export default __webpack_public_path__ + "static/gs-4-copysnidbit--mobile-3c6166fbfe7d9f7092458f940c9852c2.jpg";